import settings from '@config/settings'
import { COOKIE, COOKIE_NAME, MODAL_SIZE } from '@constants'
import CookieImage from '@icons/cookie.svg'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useContext } from 'react'
import ManageCookies from './ManageCookies'
import './CookieConsent.scss'

interface Props {
  setCookie: (name: string, value: string, options: { days: number; maxAge: number; domain: string }) => void
}

function CookieConsent({ setCookie }: Props) {
  const { modalShow } = useContext(GlobalContext)

  function handleManageCookieConsent() {
    modalShow({
      options: { size: MODAL_SIZE.MEDIUM },
      content: <ManageCookies setCookie={setCookie} />
    })
  }

  return (
    <div className='cookie-consent'>
      <div className='consent-container'>
        <div className='top-part'>
          <div className='top-content'>
            <img src={CookieImage} alt='Cookie consent' />
            <span>
              {tr(
                'FRONTEND.COOKIE_CONSENT.PERSONALISED_XP',
                'We use cookies to personalize your experience on The Guardian Bank portal. They are all about to personalize content and ads, provide social media features and to analyze our traffic.'
              )}
            </span>
          </div>

          <div className='top-buttons'>
            <Button
              type='button'
              color='primary'
              className='btn-manage'
              text={tr('FRONTEND.COOKIE_CONSENT.MANAGE_COOKIES', 'Manage cookies')}
              onClick={handleManageCookieConsent}
              data-test='button-manage-cookies'
            />

            <Button
              type='button'
              color='primary'
              className='btn-accept'
              text={tr('FRONTEND.COOKIE_CONSENT.ACCEPT_ALL', 'Accept all')}
              data-test='button-accept-all'
              onClick={() => {
                setCookie(
                  COOKIE_NAME.CONSENT,
                  JSON.stringify({
                    necessaryCookies: true,
                    optionalCookies: true
                  }),
                  {
                    days: COOKIE.EXPIRATION_DAYS,
                    maxAge: COOKIE.MAX_AGE_SECONDS,
                    domain: settings.cookieDomain
                  }
                )
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
